import styled from "styled-components";

export const LoadingWrapper = styled.div<{
  fitParent?: boolean;
  background?: string;
  height?: string;
}>`
  position: absolute;
  height: ${(p) => (p.height ? p.height : p.fitParent ? "100%" : "100vh")};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(p) =>
    p.background ? p.background : "var(--task-eva-content-bg)"};
  color: var(--main-color);
  z-index: 2003;
`;
export const Spinner = styled.div`
  .loading-span {
    position: relative;
    display: inline-block;
    font-size: 32px;
    width: 1em;
    height: 1em;
    transform: rotateZ(45deg);
    transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    animation: Rotate45 1.2s infinite linear;
  }

  .loading-span > i {
    height: 14px;
    width: 14px;
    background-color: var(--main-color);
    display: block;
    position: absolute;
    border-radius: 100%;
    transform: scale(0.75);
    transform-origin: 50% 50%;
    opacity: 0.3;
    animation: myAnimationMove 1s infinite linear alternate;
  }

  .loading-span:nth-child(1) {
    top: 0;
    left: 0;
  }

  .loading-span :nth-child(2) {
    top: 0;
    right: 0;
    animation-delay: 0.4s;
  }

  .loading-span :nth-child(3) {
    bottom: 0;
    right: 0;
    animation-delay: 0.8s;
  }

  .loading-span :nth-child(4) {
    left: 0;
    bottom: 0;
    animation-delay: 1.2s;
  }

  .loading-container > .text-container {
    padding-top: 5px;
    text-shadow: 0 1px 2px #fff;
    color: #00d8ff;
    font-variant: tabular-nums;
    font-feature-settings: "tnum";
    font-size: 14px;
  }

  @keyframes Rotate45 {
    to {
      transform: rotate(405deg);
    }
  }

  @keyframes myAnimationMove {
    to {
      opacity: 1;
    }
  }
`;
export const SpinnerText = styled.div`
  margin-top: 10px;
  font-size: 14px;
`;
